import { render, staticRenderFns } from "./BaseScrollToTop.vue?vue&type=template&id=f69bb206&scoped=true&"
import script from "./BaseScrollToTop.vue?vue&type=script&lang=js&"
export * from "./BaseScrollToTop.vue?vue&type=script&lang=js&"
import style0 from "../assets/css/base.css?vue&type=style&index=0&id=f69bb206&scoped=true&lang=css&"
import style1 from "./BaseScrollToTop.vue?vue&type=style&index=1&id=f69bb206&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f69bb206",
  null
  
)

export default component.exports